import EditorPR from "./EditorPR";

export default EditorPR;
